import { getSessionData } from '@speeki/apollo-utils';
import { ExternalTokenPayload } from '@speeki/auth';
import { StorageManager } from '@speeki/storage-manager';

import { TargetsCardQuery } from '@graphql/generated/graphql';

type TargetData = NonNullable<
    TargetsCardQuery['targetList']['edges'][number]['node']['targetData']
>[number];

export const getDecodedToken = (): ExternalTokenPayload | null => {
    const sessionToken = StorageManager.getValue('graphSessionToken') || '';

    return getSessionData(sessionToken);
};

const findTargetElement = (
    targetData: TargetData[] | undefined | null,
    predicate: (item: TargetData) => boolean,
) => targetData?.find(predicate);

export const calculateTargetUnitsValue = ({
    isOverallTarget,
    targetData,
    targetYear,
}: {
    isOverallTarget: boolean;
    targetData: TargetData[] | undefined | null;
    targetYear?: number;
}) => {
    const currentYear = new Date().getFullYear();
    let targetUnitsValue = 0;

    if (isOverallTarget && targetYear) {
        const targetYearElementTargetValue =
            findTargetElement(targetData, (item) => item.year === targetYear)
                ?.predictedValue || 0;

        targetUnitsValue = targetYearElementTargetValue;
    } else {
        const nextYearElementTargetValue =
            findTargetElement(
                targetData,
                (item) => item.year === currentYear + 1,
            )?.predictedValue || 0;

        targetUnitsValue = nextYearElementTargetValue;
    }

    return targetUnitsValue;
};
